export default {
  MODULE_NAME: 'usage',
};
